module.exports = __webpack_public_path__ + "img/default_logo.6531f6b1.svg";